import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getUserDayTimes ,getUserPieChart, getUserLineChart } from "../../api/user.api";
import { getBranchUserRoles, assignUserRole } from "../../api/role.api";
import EditWorkingHoursModal from "../../components/EditWorkingHoursModal/EditWorkingHoursModal";
import "./UserDetail.css";
import UserCharts from "../../components/UserCharts/UserCharts"
export default function UserDetail() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [times, setTimes] = useState([]);
    const [role, setRole] = useState("");
    const [roles, setRoles] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [loadingRole, setLoadingRole] = useState(false);
    const [pieData, setPieData] = useState(null);
    const [lineData, setLineData] = useState(null);

    const users =
        JSON.parse(localStorage.getItem("branch_users")) || [];

    const branch =
        JSON.parse(localStorage.getItem("branch"));

    const user = users.find((u) => u.id === Number(id));

    useEffect(() => {
        load();
    }, []);

    const load = async () => {
        try {
            const data = await getUserDayTimes(id);
            setTimes(data);
            const pie = await getUserPieChart(id);
            setPieData(pie);

            const line = await getUserLineChart(id);
            setLineData(line);

            setRole(user?.role_id || "");

            if (branch?.id) {
                const roleData = await getBranchUserRoles(branch.id);
                setRoles(roleData);
            }
        } catch (err) {
            console.error("Load error:", err);
        }
    };

    // ✅ POST orqali role assign qilish
    const handleRoleChange = async (newRoleId) => {
        if (!newRoleId) return;

        try {
            setLoadingRole(true);
            setRole(newRoleId);

            await assignUserRole(Number(id), newRoleId);

            // 🔥 localStorage ni ham update qilamiz
            const updatedUsers = users.map((u) =>
                u.id === Number(id)
                    ? { ...u, role_id: newRoleId }
                    : u
            );

            localStorage.setItem(
                "branch_users",
                JSON.stringify(updatedUsers)
            );

        } catch (err) {
            console.error("Role assign error:", err);
            alert("Error assigning role");
        } finally {
            setLoadingRole(false);
        }
    };

    return (
        <div className="profile-page">

            <div className="profile-top-card">

                <div className="profile-left">
                    <button
                        className="back-btn"
                        onClick={() => navigate(-1)}
                    >
                        ← Back
                    </button>

                    <div className="profile-info">
                        <h2>{user?.name}</h2>
                        <span>ID: {user?.id}</span>
                    </div>
                </div>

                <div className="profile-actions">

                    <div className="role-control">
                        <select
                            className="role-select"
                            value={role}
                            disabled={loadingRole}
                            onChange={(e) =>
                                handleRoleChange(Number(e.target.value))
                            }
                        >
                            <option value="">
                                Select role
                            </option>

                            {roles.map((r) => (
                                <option key={r.id} value={r.id}>
                                    {r.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <button
                        className="btn-outline"
                        onClick={() =>
                            setIsEditModalOpen(true)
                        }
                    >
                        Edit Weekly Schedule
                    </button>

                </div>
            </div>

            <div className="history-card">
                <h4>Attendance History</h4>

                <div className="history-table-wrapper">
                    <table className="history-table">
                        <thead>
                        <tr>
                            <th>Date</th>
                            <th>Entry</th>
                            <th>Leave</th>
                            <th>Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        {[...times]
                            .sort(
                                (a, b) =>
                                    new Date(b.entry_time) -
                                    new Date(a.entry_time)
                            )
                            .map((t) => {
                                const entry = new Date(t.entry_time);
                                const leave = new Date(t.leave_time);

                                return (
                                    <tr key={t.id}>
                                        <td>{entry.toLocaleDateString()}</td>

                                        <td>
                                            {entry.toLocaleTimeString([], {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                            })}
                                        </td>

                                        <td>
                                            {leave.toLocaleTimeString([], {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                            })}
                                        </td>

                                        <td>
                                            {t.status?.length > 0 ? (
                                                <span className="status-badge late">
                                {t.status[0].name}
                            </span>
                                            ) : (
                                                <span className="status-badge ok">
                                On Time
                            </span>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>

                    </table>


                </div>
            </div>
            {pieData && lineData && (
                <UserCharts pieData={pieData} lineData={lineData} />
            )}
            {isEditModalOpen && (
                <EditWorkingHoursModal
                    userId={id}
                    onClose={() =>
                        setIsEditModalOpen(false)
                    }
                />
            )}
        </div>
    );
}
